<template>
  <div>
    <v-dialog
      title="Download certificate of subscription"
      v-model="downloadReady"
      max-width="650"
    >
      <v-card class="delete-dialog">
        <v-card-title class="headline dark--text">Download Ready</v-card-title>
        <v-card-text class="dark--text">Your subscription certificate is ready to download.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancel-btn" text @click="handleCancel">Cancel</v-btn>
          <v-btn class="save-btn" text @click="handleDownload">Start download</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="subscription-wrap">
      <v-card class="light-card">
        <v-toolbar color="primary" id="toolbar">
          <div class="d-flex flex-column justify-content-between align-items-center">
            <v-card-title class="top-title">{{ getSubscriptionType() + ' ' }}Subscription</v-card-title>
            <div v-if="license && license.description === 'free'" class="upgrade-button mt-5" @click="$emit('onUpgradeClick')">
              Upgrade
            </div>
          </div>
        </v-toolbar>
        <div class="card-body" v-if="license && license.description !== 'free'">
          <div class="d-flex flex-column flex-sm-row">
            <div class="d-flex flex-column col-sm-4 col-12">
              <h3>Term</h3>
              <span class="mt-2">{{ license ? epochToDate(license.date_created) : '' }} - {{ license ? epochToDate(license.expiry) : '' }}</span>
            </div>
            <div class="d-flex flex-column col-sm-4 col-12">
              <h3>Next Payment Date</h3>
              <span class="mt-2">{{ license ? epochToDate(license.expiry) : '' }}</span>
            </div>
            <div class="d-flex flex-column col-sm-4 col-12">
              <h3>Payment Method</h3>
              <span class="mt-2">Credit Card</span>
            </div>
          </div>
          <div class="px-3 py-3">
            <a @click="downloadSubscriptionCertificate">Certificate of Subscription</a>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import api from 'Api'
import { capitalizeFirstLetter } from '@/utils/main_helper.js'

export default {
  name: 'subscription',
  data () {
    return {
      downloadReady: false,
      downloadUrl: null
    }
  },
  computed: {
    ...mapGetters(['license', 'currentOrganization']),
    ...mapState({
      loading: state => state.billingServices.loading,
      paymentInformation: state => state.billingServices.paymentInformation
    })
  },
  methods: {
    epochToDate (epoch) {
      try {
        const d = new Date(epoch * 1000)
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' })
        const [{ value: month },, { value: day },, { value: year }] = dateTimeFormat.formatToParts(d)

        return `${month} ${day}, ${year}`
      } catch (err) {
        return ''
      }
    },
    getSubscriptionType () {
      return this.license ? capitalizeFirstLetter(this.license.description) : ''
    },
    async downloadSubscriptionCertificate () {
      const res = await api().get(`/subscription/certificate/${this.currentOrganization.entity_id}`)
      this.downloadUrl = res.data
      this.downloadReady = true
    },
    handleDownload () {
      window.open(this.downloadUrl, '_blank')
      this.downloadReady = false
    },
    handleCancel () {
      this.downloadUrl = null
      this.downloadReady = false
    },
    getAllInvoices (entityId) {
      if (!entityId) return
      this.$store.dispatch('getAllInvoices', entityId)
    }
  },
  watch: {
    'currentOrganization.entity_id' (entityId) {
      this.getAllInvoices(entityId)
    }
  }
}
</script>
<style scoped lang="scss">
  ::v-deep {
    .card-body {
      padding: 10px;
      .v-list {
        .v-list-item {
          border-bottom: 1px solid #f1f1f1;
          .v-list-item__action {
            .theme--light.v-icon {
              color: #000;
              &:after {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  .upgrade-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    color: #212338;
    font-family: "gt_america_extendedBd";
    font-size: 13px;
    letter-spacing: 1.97px;
    line-height: 17px;
    text-align: center;
    height: 36px;
    width: 160px;
    border-radius: 25px;
    background-color: #3ACA56;
    cursor: pointer;
  }
</style>
